module.exports = __webpack_public_path__ + "static/img/third1_2.5d271926.png";